import React, { FC } from "react";

type Props = {
  loading?: boolean;
  hasNoResult?: boolean;
};

const SelectEmptyState: FC<Props> = ({ hasNoResult, loading }) => {
  if (loading) {
    return <div className="select__empty-state">Loading...</div>;
  }

  if (hasNoResult) {
    return <div className="select__empty-state">No result for search...</div>;
  }

  return (
    <div className="select__empty-state">
      Type 3 or more letters to search...
    </div>
  );
};

export default SelectEmptyState;
